/**
 * @file store文件
 */
import Vue from 'vue';
import Vuex from 'vuex';
import {fetchNAParams} from '../helper/util';
import * as Types from './mutation-types';
import {
    formatMark, formatReplyList, formatMessageList,
    newRemoveRepeation, formatTabList, removeLastRepeation
} from './dataFormater';
import {getParamsFromUrl, captureException, getPlatInfo} from '@baidu/map-fe-utils';
import fetchData from '../service';
// import newMain from './modules/newMain';
import theme from './modules/theme';
import feedBack from './modules/feedBack';
import rankDetail from './modules/rankDetail';
import detail from './modules/detail';
import redPacket from './modules/redPacket';
// import pano from './modules/pano';

import request from '@/pages/pano-feed/request.js';
import {getTab, getPanoAuthor} from '@/pages/pano-feed/constant/RequestConfig.js';

Vue.use(Vuex);

// 是否是端外环境
const isOutMap = !getPlatInfo().isNative && getParamsFromUrl().source === 'outmap';
const isNative = getPlatInfo().isNative;

const state = {
    isPanoReady: false,
    urlParams: {},
    // isGyroscopeActive: false, // 陀螺仪是否开启
    // isMusicActive: false, // 音乐是否开启
    panoList: [], // 一次请求的全景数据数组 TODO: 未使用？
    // panoInfo: null, // 当前pid对应的全景信息（简介、点赞数、分享数）

    preIsTouch: false, // 是否触摸屏幕的前一个状态
    isTouch: false, // 是否触摸屏幕

    linksControlStatus: true, // 道路箭头 TODO: 建议直接操作引擎实例

    // 登录信息
    loginInfo: {
        curHeadImg: '',
        curUserName: '',
        isLogin: false
    },

    isMenuShow: false, // 是否展示菜单面板
    isShowHeader: true, // 是否展示头部

    // isMessageShow: true, // 看留言开关是否开启，默认开启
    // isControlBoardShow: false, // 信息展示面板是否展示

    // 留言相关的
    isMessageBoardShow: false, // 是否展示留言详情面板
    currentMakerInfo: {}, // 当前留言marker信息
    markList: [], // 留言mark数据
    likedInfo: {}, // 留言mark 根据id 存点赞状态
    replyInfos: [], // 回复列表数据
    hasNext: false, // 回复列表是否有下一页
    total: 0, // 回复列表总条数
    replyLikedInfo: null, // 回复数据 根据id存点赞状态
    recomTopic: [], // 发表留言，推荐话题列表
    recomMark: [], // 发表留言，推荐留言列表
    isShowWriteMessage: false, // 是否展示 写留言面板

    isFullScreen: false, // 是否要清屏

    // 分享按钮 点击时的信息
    isShareClickedInfo: {
        isClicked: false,
        shareNum: 0
    },

    // 三期
    msgCountNum: 0, // 评论总数目
    curTabIndex: 0, // 当前第几个 tab
    isAllMessageShow: false, // 控制全部留言开关
    allMessageList: [], // 全部留言数据列表
    hasPage: 0, // 全部留言feed列表是否是最后一页

    // 四期
    tabList: [], // 顶部tab 数据
    currentPid: '',
    curPanoInfo: null, // 当前渲染的全景数据信息

    // 六期
    // 页面初始化时选中的tab
    defaultChannel: {
        name: '',
        id: ''
    },
    udcState: 1, // 客户端的个性化全景推荐开关 标识位(默认打开)
    baidumapNet: '', // 客户端信息里的网络参数
    isDirectDateSend: false, // url透传的日期是否传递给接口一次
    isShowNoticeTip: true,
    cityId: '',

    // 八期
    isHotListShow: false,
    rankShowFr: 'tabclick',

    panoAuthorInfo: null, // 全景ugc用户（淘金，路淘和全民共建类型）信息

    // 是否离开全景流
    panoActivated: true
};

const getters = {
    isLogin: state => state.loginInfo.isLogin,
    stbarHeight: state => Number(state.urlParams.stbar_height || 0) + 12, // 状态栏高度
    currentPanolist() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].panoList;
        }
    },
    currentPanolistCurIndex() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].listCurIndex;
        }
    },
    currentPanolistMaxIndex() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].maxIndex;
        }
    },
    // 统计用
    currentTabName() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].name || 'tuijian';
        }
        return 'theme';
    },
    // 类抖音用

    curRenderList() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].renderList;
        }
    },
    // 当前的删除次数
    curDelNum() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].deleteNum;
        }
    },
    curSwiperListIndex() {
        if (state.tabList.length) {
            return state.tabList[state.curTabIndex].swiperListAcNum;
        }
    },
    isMessageClear: state => {
        return state.isFullScreen || state.isHotListShow || !state.panoActivated;
    }
};
const mutations = {
    [Types.GET_URL_PARAM](state, data) {
        state.urlParams = data;
    },
    // [Types.UPDATE_GYROSCOPE_STATUS](state, data) {
    //     state.isGyroscopeActive = data;
    // },
    // [Types.UPDATE_MUSIC_PLAYING_STATUS](state, data) {
    //     state.isMusicActive = data;
    // },

    [Types.SET_LINKS_CONTROL_STATUS](state, data) {
        state.linksControlStatus = data;
    },

    // 是否触摸屏幕，控制全景旋转
    [Types.SET_IS_TOUCH](state, data) {
        state.isTouch = data;
    },
    // 保留触摸屏幕时的前一个状态（留言详情弹框关闭时用）
    [Types.SET_PRE_TOUCH](state, data) {
        state.preIsTouch = data;
    },
    [Types.SET_IS_PANO_READY](state, data) {
        state.isPanoReady = data;
    },
    // 登录信息
    [Types.SET_LOGIN_INFO](state, data) {
        state.loginInfo.isLogin = data.isLogin;
        state.loginInfo.curHeadImg = decodeURIComponent(data.helperImage);
        state.loginInfo.curUserName = data.username;
    },
    [Types.SET_HEADER_STATUS](state, data) {
        state.isShowHeader = data;
    },
    // 留言详情面板显示控制
    [Types.SET_MESSAGE_BOARD_SHOW_STATUS](state, data) {
        state.isMessageBoardShow = data;
    },
    // 当前点击留言marker的数据
    [Types.SET_CURRENT_MARKER_INFOS](state, data) {
        state.currentMakerInfo = data;
    },
    // 删除对应id的留言
    [Types.DELETE_MESSAGE_BY_ID](state, markid) {
        // 寻找到这个markid的Index
        let markIndex = -1;
        state.markList.forEach((item, index) => {
            if (markid === item.markid) {
                markIndex = index;
            }
        });
        if (markIndex < 0) {
            throw Error('markid not found');
        }
        state.markList.splice(markIndex, 1);
    },
    // 删除对应id的回复数据
    [Types.DELETE_REPLY_BY_ID](state, replyid) {
        let replyindex = -1;
        state.replyInfos.forEach((item, index) => {
            if (replyid === item.id) {
                replyindex = index;
            }
        });
        if (replyindex < 0) {
            throw Error('markid not found');
        }
        state.replyInfos.splice(replyindex, 1);
        state.total--;
    },
    [Types.SET_REPLY_INFOS](state, data) {
        state.replyInfos = data;
    },
    // 回复数据 是否有下一页
    [Types.SET_REPLY_INFOS_HASNEXT](state, data) {
        state.hasNext = data.hasnext;
        state.total = data.total;
    },
    // 回复的总条数设置
    [Types.SET_REPLY_INFOS_TOTAL](state, data) {
        state.total = data;
    },
    [Types.SET_REPLY_LIKED_INFOS](state, data) {
        state.replyLikedInfo = data;
    },
    // 清除留言信息
    [Types.CLEAR_MARK_INFOS](state) {
        state.replyLikedInfo = null;
        state.replyInfos = [];
        state.currentMakerInfo = {};
    },
    // 添加新提交的回复数据
    [Types.ADD_NEW_SUBMITTED_REPLY](state, newReply) {
        newReply.isself = true;
        newReply.like_count = 0;
        newReply.isliked = false;
        const {replyLikedInfo, replies} = formatReplyList([newReply]);
        state.replyInfos.unshift(replies[0]);
        state.replyLikedInfo = {};
        state.replyLikedInfo = Object.assign(state.replyLikedInfo, replyLikedInfo);
        state.total++;
    },
    // 写留言面板数据
    [Types.SET_RECOM_LIST](state, data) {
        if (data.topic_list && data.topic_list.length) {
            state.recomTopic = data.topic_list;
        }

        if (data.mark_list && data.mark_list.length) {
            state.recomMark = data.mark_list;
        }
    },
    [Types.SET_MARK_LIKED_INFO](state, data) {
        state.likedInfo = data;
    },
    // 根据留言id设置 是否点赞
    [Types.SET_LIKE_BY_ID](state, payload = {}) {
        const {markid, isLike} = payload;
        // 触发mark 的 watch
        const likedInfo = {...state.likedInfo};
        likedInfo[markid] = isLike;
        state.likedInfo = likedInfo;
        // linknum建议各组件内部独立维护，根据isLike判断是否 +1
    },
    [Types.SET_LIKE_NUM_BY_ID](state, payload = {}) {
        const {markid, num} = payload;
        let index =  state.markList.findIndex(item => item.markid === markid);
        state.markList[index].likenum = num;
    },
    // 根据回复id设置 是否点赞
    [Types.SET_REPLY_LIKE_BY_ID](state, payload = {}) {
        const {id, isLike} = payload;
        // 从state中断开链接
        let replyLikedInfo = Object.assign({}, state.replyLikedInfo);
        state.replyLikedInfo = replyLikedInfo;
        state.replyLikedInfo[id] = isLike;
    },
    // 获取留言数据
    [Types.SET_MARK_LIST](state, data) {
        state.markList = data;
    },
    // 信息展示面板控制
    // [Types.SET_CONTROL_BOARD_SHOW_STATUS](state, data) {
    //     state.isControlBoardShow = data;
    // },
    // 是否看留言开关
    // [Types.SET_MESSAGE_SHOW_STATUS](state, data) {
    //     state.isMessageShow = data;
    // },

    // 控制菜单面板
    [Types.SET_MENU_SHOW_STATUS](state, data) {
        state.isMenuShow = data;
    },
    // 写留言面板展示控制
    [Types.SET_WRITE_MESSAGE_SHOW_STATUS](state, data) {
        state.isShowWriteMessage = data;
    },
    // 清屏控制
    [Types.SET_FULL_SCREEN_STATUS](state, data) {
        state.isFullScreen = data;
    },
    // 设置全景点赞数
    // [Types.SET_PANO_LIKED_INFO](state, data) {
    //     state.panoInfo.is_like = data;
    // },
    // 设置全景分享数
    // [Types.SET_PANO_SHARE_INFO](state, data) {
    //     state.panoInfo.share_num = data;
    // },
    // 设置全景信息数据
    // [Types.SET_PANO_INFO](state, data) {
    //     state.panoInfo = data;
    // },
    // 设置一次请求的全景数据数组
    [Types.SET_PANO_LIST](state, data) {
        state.panoList = data;
    },
    // 设置点击分享时的信息
    [Types.SET_SHARE_CLIKED_INFO](state, data) {
        state.isShareClickedInfo.isClicked = data.isClicked;
        if (data.isClicked) {
            state.isShareClickedInfo.shareNum = data.shareNum;
        }
    },


    // 更改当前tab index
    [Types.SET_CUR_TAB_INDEX](state, data) {
        state.curTabIndex = data;
    },

    // 更改当前tab下 panoList 的 index
    [Types.SET_CUR_TAB_LIST_INDEX](state, data) {
        state.tabList[state.curTabIndex].listCurIndex = data;
    },

    // 更改当前tab下 panoList 的 最大index，为了上一个的时候不发统计时长
    [Types.SET_CUR_TAB_LIST_MAX_INDEX](state, data) {
        state.tabList[state.curTabIndex].maxIndex = data;
    },

    // 更改当前tab curTabIndex下的 panoList
    [Types.SET_CUR_TAB_PANO_LIST](state, data) {
        state.tabList[state.curTabIndex].panoList = data;
    },

    // 更改推荐下的 panoList
    [Types.SET_DEFAULT_PANO_LIST](state, data) {
        state.tabList[data.index].panoList = data.list;
    },

    // 更改当前全景 index
    [Types.SET_MSG_COUNT_NUM](state, data) {
        state.msgCountNum = data;
    },

    // 全部留言是否是最后一页
    [Types.SET_IS_LAST_PAGE](state, data) {
        state.hasPage = data;
    },

    // 更改全部留言数据 list
    [Types.SET_ALL_MESSAGE_LIST](state, data) {
        state.allMessageList = data;
    },
    // 删除全部留言下 对应id的留言
    [Types.DELETE_ALL_MESSAGE_BY_ID](state, markid) {
        let markIndex = -1;
        state.allMessageList.forEach((item, index) => {
            if (markid === item.markid) {
                markIndex = index;
            }
        });
        if (markIndex < 0) {
            throw Error('markid not found');
        }
        state.allMessageList.splice(markIndex, 1);
    },
    // 全部留言面板控制
    [Types.SET_ALL_MESSAGW_SHOW_STATUS](state, data) {
        state.isAllMessageShow = data;
    },

    // 调高锚定 marker 的 rank值
    [Types.SET_CHOOSEN_MARKER_RANK](state, data) {
        state.markList[data].rank = 9999;
    },

    /** 四期 */
    // 设置全景tab数据
    [Types.SET_TAB_LIST](state, data) {
        state.tabList = data;
    },
    // 设置当前全景数据信息(简介、分享、点赞数)
    [Types.SET_CUR_PANO_INFO](state, data) {
        state.curPanoInfo = data;
    },
    // 设置当前pid
    [Types.SET_CURRENT_PID](state, data) {
        state.currentPid = data;
    },
    // swiper 渲染数组
    [Types.SET_RENDER_LIST](state, data) {
        state.tabList[data.index].renderList = data.list;
    },
    // 为了保证性能删除一部分数据，删除的次数
    [Types.SET_DELETE_NUM](state, data) {
        state.tabList[state.curTabIndex].deleteNum = data;
    },
    // 为了保证性能删除一部分数据，删除的次数
    [Types.SET_SWIPER_AC_NUM](state, data) {
        state.tabList[state.curTabIndex].swiperListAcNum = data;
    },
    [Types.SET_UDC](state, data) {
        state.udcState = data;
    },
    [Types.SET_BAIDUMAP_NET](state, data) {
        state.baidumapNet = data;
    },
    [Types.SET_NOTICE_TIP_STATUS](state, data) {
        state.isShowNoticeTip = data;
    },
    [Types.SET_CITY_ID](state, data) {
        state.cityId = data;
    },
    // 热榜组件展示控制
    [Types.SET_HOT_LIST_STATUS](state, data) {
        state.isHotListShow = data;
    },
    [Types.SET_RANK_SHOW_FR](state, data) {
        state.rankShowFr = data;
    },
    // 点赞后改变当前点赞数
    [Types.SET_LIKE_NUM](state, data) {
        let index = state.tabList[state.curTabIndex].listCurIndex;
        state.tabList[state.curTabIndex].panoList[index].like_num = data;
    },

    [Types.SET_PANO_AUTHOR_INFO](state, data) {
        // if (data.date && data.author) {
        if (data.author) {
            state.panoAuthorInfo = data;
        }
        else {
            state.panoAuthorInfo = null;
        }
    },

    [Types.SET_PANO_ACTIVATED](state, data) {
        state.panoActivated = data;
    }
};

const actions = {
    checkLogin: ({commit}) => {
        return fetchData('checkLogin').then(res => {
            if (res.errno === 0) {
                commit(Types.SET_LOGIN_INFO, res.data || {});
            }
        });
    },
    getUrlParams: ({commit}) => {
        return fetchNAParams()
            .then(result => {
                commit(Types.GET_URL_PARAM, result);
                // 获取客户端网络net参数
                if (getPlatInfo().isNative) {
                    commit(Types.SET_BAIDUMAP_NET, result.net);
                }
            });
    },

    /**
     * 关闭消息面板
     */
    handleMessageBoardClose({commit, state}) {
        if (state.isMessageBoardShow === true) {
            commit(Types.SET_MESSAGE_BOARD_SHOW_STATUS, false);
            commit(Types.CLEAR_MARK_INFOS);
        }
    },

    /**
      * 关闭信息展示面板
      */
    // handleControlBoardClose({commit, state}) {
    //     if (state.isControlBoardShow === true) {
    //         commit(Types.SET_CONTROL_BOARD_SHOW_STATUS, false);
    //         if (isNative) {
    //             window.history.back();
    //         }
    //     }
    // },
    /**
      * 关闭全部留言面板
      * TODO: 待验证
      */
    handleAllMessageClose({commit, state}) {
        if (state.isAllMessageShow === true) {
            commit(Types.SET_ALL_MESSAGW_SHOW_STATUS, false);
            // if (isNative) {
            // window.history.back();
            // }
        }
    },
    /**
      * 关闭提示条
      */
    handleNoticeTipClose({commit, state}) {
        if (state.isShowNoticeTip === true) {
            commit(Types.SET_NOTICE_TIP_STATUS, false);
        }
    },
    /**
      * 关闭热榜
      */
    handleHotListClose({commit, state}) {
        if (state.isHotListShow) {
            commit(Types.SET_HOT_LIST_STATUS, false);
        }
    },
    getMarks: ({commit, state}, {pid, markid, heading, pitch, uid = ''}) => {
        let cuid = decodeURIComponent(state.urlParams.cuid); // IOS url参数会被编码，这里反解一次
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        let loc = window.btoa((0, 0));
        let sv = state.urlParams.sv || '15.10.18';
        const params = {
            qt: 'aroundlistmarks',
            pid,
            from: 'h5map',
            loc,
            radius: 200,
            needtags: 0,
            cuid,
            'mark_id': markid,
            poi_uid: uid,
            pano_type: 2,
            heading,
            pitch,
            is_from_jingpin: 1,
            sv
        };
        const options = {
            noCuid: noCuid,
            need_sign: 1,
            outmap: isOutMap
        };
        return fetchData('getMark', params, options).then(res => {
            if (res && res.result && res.result.error === 0) {
                const messagelist  = res.content.messagelist || [];
                const {marksInfo, likedInfo} = formatMark(messagelist);
                commit(Types.SET_MARK_LIST, marksInfo);
                commit(Types.SET_MARK_LIKED_INFO, likedInfo);
                commit(Types.SET_MSG_COUNT_NUM, res.content.msgcount);
            }
            else {
                throw res.result.msg || '网络繁忙，请稍后再试';
            }
        }).catch(e => {
            throw e;
        });
    },
    voteMark: ({state}, param) => {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const fetchParams = {
            cuid,
            qt: 'votemark',
            voteData: JSON.stringify([param])
        };

        return fetchData('voteMark', fetchParams, {noCuid: noCuid, need_sign: 1});
    },
    // 删除留言或者回复，isAllDelFlag：是否是在全部留言面板删除
    delMark: ({state, commit}, {param, messageType, isAllDelFlag}) => {
        const cuid = decodeURIComponent(state.urlParams.cuid);
        const originParam = {
            qt: 'delmark',
            cuid
        };
        const fetchParam = Object.assign({}, param, originParam);
        return fetchData('delMark', fetchParam, {need_sign: 1}).then(res => {
            if (res && res.result && res.result.error === 0) {
                if (messageType === 'normal') {
                    if (isAllDelFlag) {
                        // 若是在全部留言面板删除，需要更新全部留言数据
                        commit(Types.DELETE_ALL_MESSAGE_BY_ID, param.markid);
                    }
                    commit(Types.DELETE_MESSAGE_BY_ID, param.markid);
                }
                else if (messageType === 'reply') {
                    commit(Types.DELETE_REPLY_BY_ID, param.reply_id);
                }
            }
        });
    },

    /**
      * 添加评论
      * @param {Object} context -
      * @param {Object} param - {pid, x, y, z, coordinate, topic_id, topic_title, share_userid}
      * @see => http://wiki.baidu.com/pages/viewpage.action?pageId=1147616491#id-%E5%85%A8%E6%99%AF%E5%9B%BEUGC%E8%AF%84%E8%AE%BA%E5%8D%8F%E8%AE%AE-2%E3%80%81qt=delmark
      */
    addMark: ({}, param) => {
        const cuid = state.urlParams.cuid;
        param.cuid = cuid;
        param.qt = 'addmark';
        const options = {
            need_sign: 1
        };
        // addmark接口没有签名校验
        return fetchData('addMark', param, options).then(res => {
            if (res && res.result && res.result.error === 0) {
                const content = res.content || {};
                return content;
            }

            throw res.result.msg || '网络繁忙，请稍后再试';

        }).catch(e => {
            let err = e instanceof Error ? e : JSON.stringify(e);
            const myErrorMessage = {
                netWork: state.baidumapNet,
                message: `addMark error:${err}`
            };
            captureException('addMarkError', JSON.stringify(myErrorMessage));
            throw e;
        });
    },
    submitReply: ({state, commit}, param) => {
        const originParam = {
            qt: 'replysubmit'
        };
        const fetchParam = Object.assign({}, param, originParam);
        return fetchData('submitReply', fetchParam, {need_sign: 1}).then(res => {
            if (res && res.result && res.result.error === 0) {
                commit(Types.ADD_NEW_SUBMITTED_REPLY, res.content);
            }
            else {
                throw res.result.msg || '网络繁忙，请稍后再试';
            }
        });
    },
    getReplyInfos({state, commit}, params) {
        const cuid = decodeURIComponent(state.urlParams.cuid);
        const originParam = {
            qt: 'replyfeed',
            cuid
        };
        const fetchParam = Object.assign({}, params, originParam);

        return fetchData('getReplyList', fetchParam, {need_sign: 1})
            .then(res => {
                if (res && res.content) {
                    if (res.content.replylist && res.content.replylist.length > 0) {
                        const {replyLikedInfo, replies} = formatReplyList(res.content.replylist);
                        // 分页数据追加
                        const replyData  = state.replyInfos.concat(replies);
                        const replyLikedInfoData = Object.assign({}, state.replyLikedInfo, replyLikedInfo);

                        commit(Types.SET_REPLY_INFOS, replyData);
                        commit(Types.SET_REPLY_LIKED_INFOS, replyLikedInfoData);
                    }
                    commit(Types.SET_REPLY_INFOS_HASNEXT, res.content);
                }
            })
            .catch(e => {
                console.error(e);
                throw (e);
            });
    },

    /**
      * 发表留言，更新数据
      */
    addNewSubmittedMark: ({commit, state}, markInfo) => {
        const copy = [].concat(state.markList);
        copy.push(markInfo);
        commit(Types.SET_MARK_LIST, copy);
        if (state.likedInfo) {
            const likedInfo = Object.assign({}, state.likedInfo, {[markInfo.markid]: false});
            commit(Types.SET_MARK_LIKED_INFO, likedInfo);
        }
    },

    /**
      * 获取发表留言面板的推荐内容
      */
    getFastRecoms: ({commit}) => {
        return fetchData('getFastRecoms', {
            qt: 'getfastrecoms',
            from: 'h5map'
        }).then(res => {
            if (res && res.result.error === 0 && res.content) {
                commit(Types.SET_RECOM_LIST, res.content);
            }
        }).catch(e => {
            console.error(e);
        });
    },
    // 全景信息（简介、点赞数、分享数等）
    getPanoInfo: ({commit}, params) => {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        let city_id = state.urlParams.c;
        let loc = state.urlParams.loc; // 安卓没有定位的时候 loc是空字符串
        const {abtest} = getParamsFromUrl();
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'getfeed',
            cuid
        };
        if (abtest) {
            initParams.abtest = abtest;
        }
        if (loc) {
            loc = loc.replace('(', '').replace(')', '');
            if (loc !== '0.000000,0.000000') {
                initParams.loc = loc;
            }
        }
        if (city_id) {
            initParams.city_id = city_id;
        }
        const fetchParam = Object.assign({}, params, initParams);
        // 日期参数只带一次给接口
        if (state.urlParams.direct_date && !state.isDirectDateSend) {
            state.isDirectDateSend = true;
            fetchParam.direct_date = state.urlParams.direct_date;
            // 加个兜底，url上配置了日期，也配置了默认频道，以日期为先 频道指定为推荐
            fetchParam.channel_name = '';
        }
        const options = {
            noCuid: noCuid,
            need_sign: 1,
            outmap: isOutMap
        };
        return fetchData('getPanoInfo', fetchParam, options).then(res => {
            if (res && res.result.error === 0 && res.content && res.content.length) {
                const tablist  = state.tabList;
                const data = {};
                data.index = tablist.findIndex(item => item.name === params.channel_name);
                // 原始数组
                let originList = state.tabList[data.index].panoList;
                // 因为方法复用去重数量根据请求参数定义
                let repeatNum = 2;
                // 推荐
                if (params.channel_name === '') {
                    let list = originList.concat(res.content);
                    data.list = newRemoveRepeation(list);
                }
                // 每日一新不去重
                else if (params.channel_name === 'neweveryday') {
                    data.list = originList.concat(res.content);
                }
                else {
                    data.list = originList.concat(removeLastRepeation(originList, res.content, repeatNum));
                }
                // panoList 数据存储
                commit(Types.SET_DEFAULT_PANO_LIST, data);
                return {
                    res, index: data.index
                };
            }
        }).catch(e => {
            console.error(e);
            // 发送监控
            let err = e instanceof Error ? e : JSON.stringify(e);
            const myErrorMessage = {
                netWork: state.baidumapNet,
                message: `getfeed data error:${err}`
            };
            captureException('getFeedError', JSON.stringify(myErrorMessage));
        });
    },
    // 全景点赞&取消点赞
    voteSharePano: ({state}, params) => {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            cuid,
            qt: 'updatefeednum'
        };
        const fetchParams = Object.assign({}, initParams, params);
        return fetchData('voteSharePano', fetchParams, {noCuid: noCuid, need_sign: 1});
    },
    // 核销当前全景接口（看过的场景不再推荐）
    getRecomPano: ({state}, params) => {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'updatefeednum',
            cuid,
            type: 'pv'
        };
        const fetchParams = Object.assign({}, initParams, params);
        return fetchData('voteSharePano', fetchParams, {noCuid: noCuid, need_sign: 1});
    },
    // 核销当前全景接口（看过的场景不再推荐）
    getPanoTime: ({state}, params) => {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        const initParams = {
            qt: 'updatefeednum',
            from: 'h5map',
            cuid
        };
        const fetchParams = Object.assign({}, initParams, params);
        return fetchData('voteSharePano', fetchParams, {noCuid: noCuid, need_sign: 1});
    },

    // 获取 tab 数据
    getTabData({commit, state}) {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        let abtest = decodeURIComponent(state.urlParams.abtest);
        let city_id = state.urlParams.c;
        let loc = state.urlParams.loc; // 安卓没有定位的时候 loc是空字符串
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }

        const fetchParams = {
            qt: 'channellist',
            from: 'h5map',
            panorama_recommend: state.udcState
        };

        if (loc) {
            loc = loc.replace('(', '').replace(')', '');
            if (loc !== '0.000000,0.000000') {
                fetchParams.loc = loc;
            }
        }
        if (city_id) {
            fetchParams.city_id = city_id;
        }

        let group = 10;
        let abtestArr = ['101714', '101715', '101716'];
        if (abtest) {
            let filterArr =  abtestArr.filter(item => abtest.indexOf(item) > -1);
            group = filterArr.length ? filterArr[0] : 10;
        }
        // abtest参数
        fetchParams.group_name = group;

        // url指定频道
        if (state.urlParams.direct_channel) {
            fetchParams.direct_channel = state.urlParams.direct_channel;
        }
        // 加个兜底，url上配置了日期，也配置了默认频道，以日期为先 频道指定为推荐
        if (state.urlParams.direct_date) {
            fetchParams.direct_channel = '';
        }

        if (isOutMap) {
            getTab.salt = 'Ye@ds*nDx&ns';
            fetchParams.from = 'outmap';
        }

        return request(getTab, fetchParams).then(res => {
            if (res && res.result.error === 0 && res.content) {
                const list = res.content.channel_list;
                const data = formatTabList(list);
                commit(Types.SET_TAB_LIST, data);

                // 设置默认频道
                const channel = res.content.default_channel;
                // 不管有没有给默认都要判断初始位置的索引，为了避免推荐不是第一个了
                state.defaultChannel.name = channel;
                let curIndex = list.findIndex(item => item.name === channel);
                curIndex = curIndex < 0 ? 0 : curIndex;

                // 更新当前选中的tab索引
                commit(Types.SET_CUR_TAB_INDEX, curIndex);

                state.defaultChannel.id = list[curIndex].id;
            }
        }).catch(e => {
            console.error(e);
            // 发送监控
            let err = e instanceof Error ? e : JSON.stringify(e);
            const myErrorMessage = {
                netWork: state.baidumapNet,
                message: `channellist data error:${err}`
            };
            captureException('channellistError', JSON.stringify(myErrorMessage));
            throw (e);
        });
    },

    // 获取全部留言
    getAllMessageData({commit, state}, {pid, page}) {
        let cuid = decodeURIComponent(state.urlParams.cuid);
        if (cuid === 'undefined' || cuid === undefined) {
            cuid = '';
        }
        let noCuid = cuid ? 0 : 1;
        let sv = state.urlParams.sv || '15.10.18';
        const fetchParams = {
            qt: 'msgfeed',
            pid,
            from: 'h5map',
            cuid,
            page: page,
            page_size: 10,
            poi_uid: '',
            sv
        };
        return fetchData('allMessage', fetchParams, {noCuid: noCuid, need_sign: 1}).then(res => {
            if (res && res.result.error === 0 && res.content) {
                commit(Types.SET_IS_LAST_PAGE, res.content.hasnext);
                const {replies} = formatMessageList(res.content.messagelist);
                commit(Types.SET_ALL_MESSAGE_LIST, state.allMessageList.concat(replies));
            }
        }).catch(e => {
            console.error(e);
            // 发送监控
            let err = e instanceof Error ? e : JSON.stringify(e);
            const myErrorMessage = {
                netWork: state.baidumapNet,
                message: `msgfeed data error:${err}`
            };
            captureException('msgfeedError', JSON.stringify(myErrorMessage));
        });
    },

    // 获取ugc全景用户信息
    getPanoAuthor({commit}, {pid, date, uid = ''}) {
        return request(getPanoAuthor, {pid, userid: uid, source: 'feed'}).then(res => {
            if (res.errno === 0) {
                commit(Types.SET_PANO_AUTHOR_INFO, {
                    ...(res.data || {}),
                    date
                });
            }
        });
    }
};

/* eslint-disable */
export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
    modules: {
        // newMain, // 新首页已经下线了
        theme,
        feedBack,
        rankDetail,
        detail,
        redPacket
    }
});
